import { AxiosError } from 'axios'

const handleAxiosError = (error: unknown): string => {
  if (error instanceof AxiosError) {
    const errorData = error.response?.data

    if (typeof errorData?.errors === 'string') {
      return errorData.errors
    }

    if (Array.isArray(errorData?.errors)) {
      if (errorData.errors.length > 0) {
        return errorData.errors.join('\n')
      }

      if (errorData?.error) {
        return errorData.error
      }
    }

    if (
      errorData?.errors &&
      typeof errorData.errors === 'object' &&
      !Array.isArray(errorData.errors)
    ) {
      const messages = Object.values(errorData.errors).flat()

      if (messages.length > 0) {
        return messages.join('\n')
      }

      if (errorData?.error) {
        return errorData.error
      }
    }

    if (errorData?.error) {
      return errorData.error
    }
  }

  if (error instanceof Error && error.message) {
    return error.message
  }

  return 'Произошла неизвестная ошибка'
}

export default handleAxiosError
